{
  "Payment": "Plată",
  "SalesDocument": "Document de vânzare",
  "SalesDocumentLine": "Linie document de vânzare",
  "FiscalNetLog": "Jurnal FiscalNet",
  "PatientMedicalService": "Serviciu medical prestat",
  "snapshotFields": {
    "salesDocument": "Document de vânzare",
    "patient": "Pacient",
    "company": "Firmă",
    "employee": "Angajat",
    "location": "Locație",
    "paymentMethod": "Metodă de plată",
    "amount": "Sumă",
    "cashAmount": "Sumă numerar",
    "cardAmount": "Sumă card",
    "currency": "Monedă",
    "paymentDate": "Data plății",
    "referenceNumber": "Număr de referință",
    "fiscalReceiptNumber": "Număr bon fiscal",
    "fiscalReceiptInfo": "Informații bon fiscal",
    "status": "Stare",
    "notes": "Note",
    "parentDocument": "Document părinte",
    "documentSeries": "Serie document",
    "series": "Serie",
    "type": "Tip",
    "typeCode": "Cod tip",
    "typeName": "Denumire tip",
    "documentNumber": "Număr document",
    "documentDate": "Data documentului",
    "dueDate": "Data scadenței",
    "totalAmount": "Total",
    "totalAmountWithoutVat": "Total fără TVA",
    "totalVatAmount": "Total TVA",
    "paidAmount": "Sumă achitată",
    "payerDetails": "Detalii plătitor",
    "cancellation": "Anulare",
    "cancelledAt": "Anulat la",
    "cancelledBy": "Anulat de",
    "reason": "Motiv",
    "convertedFromProforma": "Convertit din proformă",
    "convertedFromProformaNumber": "Nr. proformă sursă",
    "convertedToInvoice": "Convertit în factură",
    "convertedToInvoiceNumber": "Nr. factură rezultată",
    "convertedAt": "Convertit la",
    "patientMedicalService": "Serviciu medical prestat",
    "medicalService": "Serviciu medical",
    "code": "Cod",
    "quantity": "Cantitate",
    "unitPrice": "Preț unitar",
    "discountPercentage": "Discount (%)",
    "discountAmount": "Valoare discount",
    "totalPriceWithoutVat": "Preț total fără TVA",
    "totalPrice": "Preț total",
    "vat": "TVA",
    "vatPercentage": "TVA (%)",
    "vatAmount": "Valoare TVA",
    "lineOrder": "Ordine linie",
    "correlation": "ID corelare",
    "direction": "Direcție",
    "httpStatusCode": "Cod stare HTTP",
    "payload": "Conținut",
    "fiscalCommands": "Comenzi fiscale",
    "errorMessage": "Mesaj eroare",
    "errorDetails": "Detalii eroare",
    "durationMs": "Durată (ms)",
    "receiptNumber": "Număr bon",
    "payment": "Plată",
    "initiatedBy": "Inițiat de",
    "deviceIdentifier": "Identificator dispozitiv",
    "fiscalNetUrl": "URL FiscalNet",
    "priceList": "Listă de prețuri",
    "appointment": "Programare",
    "patientSheet": "Fișă pacient",
    "executionDate": "Data efectuării",
    "value": "Valoare",
    "adjustmentAmount": "Valoare ajustare",
    "valueBeforeDiscount": "Valoare înainte de discount",
    "discountedPercentage": "Discount (%)",
    "appointmentClosure": "Închidere programare",
    "billingStatus": "Stare facturare",
    "linkedSalesDocuments": "Documente de vânzare asociate",
    "adjustment": "Ajustare",
    "closedAt": "Închis la",
    "fullName": "Nume complet",
    "idCardSeries": "Serie CI",
    "idCardNumber": "Număr CI",
    "county": "Județ",
    "locality": "Localitate",
    "companyName": "Denumire firmă",
    "vatNumber": "Cod fiscal",
    "registrationNumber": "Nr. Reg. Com.",
    "iban": "IBAN",
    "bankName": "Bancă",
    "contactPerson": "Persoană de contact",
    "payerCompany": "Firmă plătitoare",
    "categoryName": "Categorie"
  }
}
